import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Path } from 'constants/routes';
import { Ellipsis } from 'utils/healper';

export const useHyperTestProjectName = () => {
  const CHAR_LIMIT = 32;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get('jobId');
  let projectNameData = {
    showProjectName: false,
    fullProjectName: null,
    truncatedProjectName: null,
    exceedsCharLimit: false,
  };

  const job = useSelector(
    (state) => state.hypertestJobDetail?.hypertestJobDetail?.data?.data
  );

  const isTaskPath = location.pathname === Path.TASK && jobId;

  if (isTaskPath) {
    const projectName = job?.project?.name;

    if (projectName && typeof projectName === 'string' && projectName.trim()) {
      const exceedsCharLimit = projectName.length >= CHAR_LIMIT;
      const truncatedProjectName = Ellipsis(projectName, CHAR_LIMIT);
      projectNameData = {
        showProjectName: true,
        fullProjectName: projectName,
        truncatedProjectName: truncatedProjectName,
        exceedsCharLimit: exceedsCharLimit,
      };
    }
  }

  return projectNameData;
};
